import { render } from "./PosteVertePage.vue?vue&type=template&id=a3599bec"
import script from "./PosteVertePage.vue?vue&type=script&lang=js"
export * from "./PosteVertePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__